import { render } from "./Winner.vue?vue&type=template&id=fc4ae5c8&scoped=true"
import script from "./Winner.vue?vue&type=script&lang=js"
export * from "./Winner.vue?vue&type=script&lang=js"

import "./Winner.vue?vue&type=style&index=0&id=fc4ae5c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4ae5c8"]])

export default __exports__